"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["addAddressFeedback"] = "addAddressFeedback";
  TranslationKey["addNewTelephone"] = "addNewTelephone";
  TranslationKey["addPhoneNumber"] = "addPhoneNumber";
  TranslationKey["additionalPhones"] = "additionalPhones";
  TranslationKey["cancel"] = "cancel";
  TranslationKey["confirmTelephoneDelete"] = "confirmTelephoneDelete";
  TranslationKey["delete"] = "delete";
  TranslationKey["deleteTelephone"] = "deleteTelephone";
  TranslationKey["deletedFeedback"] = "deletedFeedback";
  TranslationKey["edit"] = "edit";
  TranslationKey["editAddressFeedback"] = "editAddressFeedback";
  TranslationKey["editNumber"] = "editNumber";
  TranslationKey["editPhoneNumber"] = "editPhoneNumber";
  TranslationKey["enterActivePhone"] = "enterActivePhone";
  TranslationKey["errorOccured"] = "errorOccured";
  TranslationKey["labelWithPrefix"] = "labelWithPrefix";
  TranslationKey["needPhoneVerification"] = "needPhoneVerification";
  TranslationKey["newNumber"] = "newNumber";
  TranslationKey["noCode"] = "noCode";
  TranslationKey["phoneHelperText"] = "phoneHelperText";
  TranslationKey["phoneIsAlreadyVerify"] = "phoneIsAlreadyVerify";
  TranslationKey["phonePlaceholder"] = "phonePlaceholder";
  TranslationKey["phonePlaceholderWithPrefix"] = "phonePlaceholderWithPrefix";
  TranslationKey["primaryTelephoneNumber"] = "primaryTelephoneNumber";
  TranslationKey["resend"] = "resend";
  TranslationKey["resendInMinute"] = "resendInMinute";
  TranslationKey["save"] = "save";
  TranslationKey["savedSuccessfully"] = "savedSuccessfully";
  TranslationKey["showLess"] = "showLess";
  TranslationKey["showMore"] = "showMore";
  TranslationKey["telephoneTitle"] = "telephoneTitle";
  TranslationKey["telephoneVerificationSent"] = "telephoneVerificationSent";
  TranslationKey["thisIsMyWhatsAppNumber"] = "thisIsMyWhatsAppNumber";
  TranslationKey["tooltipPhone"] = "tooltipPhone";
  TranslationKey["tooltipPrefixPhone"] = "tooltipPrefixPhone";
  TranslationKey["unverifiedTelephoneNumber"] = "unverifiedTelephoneNumber";
  TranslationKey["useAsPrimaryTelephone"] = "useAsPrimaryTelephone";
  TranslationKey["validationLength"] = "validationLength";
  TranslationKey["validationRegex"] = "validationRegex";
  TranslationKey["validationRequired"] = "validationRequired";
  TranslationKey["validationUniquePhone"] = "validationUniquePhone";
  TranslationKey["validationValidConfirmationCode"] = "validationValidConfirmationCode";
  TranslationKey["validationValidPhone"] = "validationValidPhone";
  TranslationKey["verifiedFeedback"] = "verifiedFeedback";
  TranslationKey["verifiedPhone"] = "verifiedPhone";
  TranslationKey["verifiedPhoneLink"] = "verifiedPhoneLink";
  TranslationKey["verifiedTelephoneNumber"] = "verifiedTelephoneNumber";
  TranslationKey["verify"] = "verify";
  TranslationKey["verifyPhone"] = "verifyPhone";
  TranslationKey["warning"] = "warning";
  return TranslationKey;
}({});
